import { SortingRule } from '@ringdna/common/src/components/RdnaTable/RdnaSmartTable'
import { KeyboardEvent } from 'react'

export const COLUMN_WIDTH = 40

export type RtnPagination = {
  globalFilter: string
  pageIndex: number
  pageSize: number
  sortBy: SortingRule<Record<string, unknown>>[]
  total?: number
}

export const PAGE_SIZE = 10
export const SERVER_PAGE_OFFSET = 1
export const NO_RESULT_STATE = { title: 'No results to display', subtitle: '' }
export const PAGE_SIZES = [10, 25, 50, 75, 100]

export type Option = { label: string; value: UserStatus | License }

export enum UserStatus {
  ALL = 'all',
  ACTIVE = 'active',
  DELETED = 'deleted'
}

export const ALL_LICENSES = 'all'

export enum License {
  INTELLIGENT_DIALER = 'RingDNA Dialer',
  CONVERSATION_AI = 'Conversation AI',
  MOMENTS = 'Moments™',
  GUIDED_SELLING = 'Guided Selling',
  CALENDAR = 'Calendar Booking',
  ADMIN = 'Administrator',
  REVENUE_AI = 'Revenue AI'
}

export function userSortKeys(key: string) {
  switch (key) {
    case 'Name':
      return 'displayName'
    default:
      return key || 'createdDate'
  }
}

export function userSortDirection(desc: boolean | undefined) {
  if (desc !== undefined) {
    return desc ? 'desc' : 'asc'
  }
  return 'desc'
}

export const userStatusOptions = [
  { label: 'All Users', value: UserStatus.ALL },
  { label: 'Active', value: UserStatus.ACTIVE },
  { label: 'Deleted', value: UserStatus.DELETED }
]

export function initUserStatusFilter(queryParams: string) {
  return userStatusOptions[queryParams?.includes('userStatus=active') ? 1 : 0].value
}

export function initLicenseFilter(queryParams: string) {
  if (queryParams?.includes('dialerUsers=true')) {
    return [License.INTELLIGENT_DIALER]
  }
  if (queryParams?.includes('cai=true')) {
    return [License.CONVERSATION_AI]
  }
  if (queryParams?.includes('momentsUsers=true')) {
    return [License.MOMENTS]
  }
  if (queryParams?.includes('guidedSellingUsers=true')) {
    return [License.GUIDED_SELLING]
  }
  if (queryParams?.includes('nylasUsers=true')) {
    return [License.CALENDAR]
  }
  if (queryParams?.includes('adminUsers=true')) {
    return [License.ADMIN]
  }
  if (queryParams?.includes('revenueAIUsers=true')) {
    return [License.REVENUE_AI]
  }
}

export function getLicenseFilter(licenseFilter: string[]) {
  if (!licenseFilter) return {}
  return {
    dialerUsers: licenseFilter.includes(License.INTELLIGENT_DIALER),
    cai: licenseFilter.includes(License.CONVERSATION_AI),
    momentsUsers: licenseFilter.includes(License.MOMENTS),
    guidedSellingUsers: licenseFilter.includes(License.GUIDED_SELLING),
    nylasUsers: licenseFilter.includes(License.CALENDAR),
    adminUsers: licenseFilter.includes(License.ADMIN),
    revenueAIUsers: licenseFilter.includes(License.REVENUE_AI)
  }
}

export function title(key: string) {
  switch (key) {
    case 'adminLicense':
      return License.ADMIN
    case 'dialerLicense':
      return License.INTELLIGENT_DIALER
    case 'calendarLicense':
      return License.CALENDAR
    case 'gsLicense':
      return License.GUIDED_SELLING
    case 'caiLicense':
      return License.CONVERSATION_AI
    case 'momentsLicense':
      return License.MOMENTS
    case 'revenueAILicense':
      return License.REVENUE_AI
  }
}

export function getPaginationProps(data: any[], total: number | undefined) {
  if (data?.length === 0 || (data?.length <= PAGE_SIZE && total && total <= PAGE_SIZE)) {
    return { paginationSize: 0 }
  }
  return { paginationSizes: PAGE_SIZES, paginationSize: PAGE_SIZE }
}

export function checkKeyCode(e: KeyboardEvent<HTMLInputElement>) {
  if (e.key.toLowerCase() == 'e' || e.key == '-') {
    e.stopPropagation()
    e.preventDefault()
  }
}
